import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import ThemeToggle from "./ThemeToggle";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border-b border-gray-100 dark:border-gray-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div 
            className="text-2xl font-bold text-[#3A7CA5] cursor-pointer hover:text-[#2E6B94] transition-all duration-300 transform hover:scale-105 group"
            onClick={() => scrollToSection('hero')}
          >
            <span className="relative">
              Kinandaru
              {/* Signature underline animation */}
              <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-[#3A7CA5] to-[#E6B566] group-hover:w-full transition-all duration-500"></div>
            </span>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')} 
              className="relative text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-all duration-300 transform hover:scale-110 group"
            >
              Beranda
              <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#3A7CA5] group-hover:w-full transition-all duration-300"></div>
            </button>
            <button 
              onClick={() => scrollToSection('about')} 
              className="relative text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-all duration-300 transform hover:scale-110 group"
            >
              Tentang
              <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#3A7CA5] group-hover:w-full transition-all duration-300"></div>
            </button>
            <button 
              onClick={() => scrollToSection('projects')} 
              className="relative text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-all duration-300 transform hover:scale-110 group"
            >
              Projek
              <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#3A7CA5] group-hover:w-full transition-all duration-300"></div>
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="relative text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-all duration-300 transform hover:scale-110 group"
            >
              Kontak
              <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#3A7CA5] group-hover:w-full transition-all duration-300"></div>
            </button>
            <ThemeToggle />
          </nav>

          {/* Mobile Menu Button & Theme Toggle */}
          <div className="md:hidden flex items-center gap-3">
            <ThemeToggle />
            <button 
              className="text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-colors duration-200"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden pb-4 animate-slideDown">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('hero')} 
                className="text-left text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-all duration-300 hover:translate-x-2"
              >
                Beranda
              </button>
              <button 
                onClick={() => scrollToSection('about')} 
                className="text-left text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-all duration-300 hover:translate-x-2"
              >
                Tentang
              </button>
              <button 
                onClick={() => scrollToSection('projects')} 
                className="text-left text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-all duration-300 hover:translate-x-2"
              >
                Projek
              </button>
              <button 
                onClick={() => scrollToSection('contact')} 
                className="text-left text-gray-600 dark:text-gray-300 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-all duration-300 hover:translate-x-2"
              >
                Kontak
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;